var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysicalAiBannerIllustrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 597 556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #68c9df;\n      }\n\n      .cls-3, .cls-2, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-6 {\n        fill: #acadac;\n        stroke: #ddd;\n      }\n\n      .cls-3, .cls-7, .cls-11 {\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke: #68c9df;\n      }\n\n      .cls-4, .cls-12, .cls-13, .cls-5, .cls-14, .cls-7, .cls-8, .cls-15, .cls-11 {\n        fill: none;\n      }\n\n      .cls-4, .cls-14, .cls-8, .cls-11 {\n        stroke: #000;\n      }\n\n      .cls-16 {\n        fill: #1c1c1b;\n      }\n\n      .cls-12 {\n        stroke-width: 2px;\n      }\n\n      .cls-12, .cls-5, .cls-14, .cls-7, .cls-8, .cls-9, .cls-15 {\n        stroke-linecap: round;\n      }\n\n      .cls-12, .cls-5, .cls-9, .cls-10, .cls-15 {\n        stroke: #1c1c1b;\n      }\n\n      .cls-12, .cls-14, .cls-15 {\n        stroke-linejoin: round;\n      }\n\n      .cls-17, .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-18 {\n        fill: #3364ab;\n      }\n\n      .cls-19 {\n        fill: #3949ab;\n      }\n\n      .cls-20 {\n        fill: #1a5945;\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-22 {\n        fill: #2ba17f;\n      }\n\n      .cls-7 {\n        stroke: #fff;\n      }\n\n      .cls-23 {\n        fill: #a8b7f4;\n      }\n\n      .cls-9 {\n        fill: #fbe3da;\n      }\n\n      .cls-24 {\n        fill: #d0daf7;\n      }\n\n      .cls-10 {\n        stroke-width: .5px;\n      }\n\n      .cls-25 {\n        fill: #eb6e4c;\n      }\n\n      .cls-26 {\n        fill: #536dfe;\n      }\n\n      .cls-27 {\n        fill: #fcbf18;\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M490.5,280.5c-2.7,14.1-16.4,23.5-30.6,20.8-14.1-2.7-23.5-16.4-20.8-30.6,2.7-14.1,16.4-23.5,30.6-20.8s23.5,16.4,20.8,30.6ZM450.8,272.9c-1.5,7.7,3.6,15.2,11.3,16.7,7.7,1.5,15.2-3.6,16.7-11.3s-3.6-15.2-11.3-16.7c-7.7-1.5-15.2,3.6-16.7,11.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M490.5,280.5c-2.7,14.1-16.4,23.5-30.6,20.8-14.1-2.7-23.5-16.4-20.8-30.6,2.7-14.1,16.4-23.5,30.6-20.8s23.5,16.4,20.8,30.6ZM451.1,273c-1.4,7.6,3.5,14.9,11.1,16.4,7.6,1.4,14.9-3.5,16.4-11.1,1.4-7.6-3.5-14.9-11.1-16.4-7.6-1.4-14.9,3.5-16.4,11.1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 227.3,
    y: 47.6,
    width: 296.6,
    height: 436.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 231.5,
    y: 51.8,
    width: 296.6,
    height: 436.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 235.7,
    y: 56,
    width: 296.6,
    height: 436.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "509.6 92.9 505.1 77.3 492.8 87.4 509.6 92.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M500.2,86.9c-6.1,12.9-19.1,22.1-34.3,22.6-18.7.6-34.9-12.2-39.2-29.7l-5.1.2c4.5,20.3,23,35.2,44.5,34.5,17.2-.5,31.8-10.8,38.7-25.4-1.5-.7-3-1.4-4.5-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M463.3,26.1c-16.9.5-31.4,10.5-38.4,24.8l4.5,2.2c6.2-12.6,19-21.5,34-21.9,19.5-.6,36.2,13.3,39.7,31.9l5.1-.2c-3.6-21.4-22.6-37.4-44.9-36.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M419.7,47l4.2,15,12.8-9.5c-5.6-1.9-11.3-3.7-17-5.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M168.9,504.3c-4.1,1.6-9.2,1.3-14.3.8-11-1.5-9-1-10.2-9.5-1.2-8.6-2.9-30.7-1.9-39.4.3-2.6.9-5.3,2.4-7.4,2.2-3.2,6.1-4.7,9.8-6,2.6-.9,5.3-1.8,8.1-2.1,4.9-.6,10.2.6,13.9,3.9,5.7,5,3.1,11.8,2.9,18.6-.4,10.6-2.4,26.8-3.5,36.9-.4,4.3-4.1,2.9-7.2,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M143.8,505.1c0-2.6,0-5.3.5-7.9,5.7,0,11.5.2,17.2.2,2.9,0,5.7,0,8.6.1,2.4,0,5.1-.5,7.4,0,.1,2.5.5,4.9,1.2,7.3.1.5.3,1.1.8,1.5.4.3.9.4,1.3.5,9.6,1.8,19.7,2.9,28,8.2,1.6,1,3.3,2.9,2.4,4.6-1.1,2-6.7,2-8.7,2.2-3.7.3-7.5,0-11.2-.3-7.7-.6-15.5-.7-23.2-.3-2.2.1-5.1.5-7.2-.4-1.8-.7-2.4-3.1-4-3.7-.1,1.4-.4,2.7-.8,4,0,.1,0,.2-.2.3-.1.2-.4.2-.6.2-2.3,0-5.4.6-7.6,0-2.4-.6-2.4-2.9-2.7-5.1-.5-3.8-1-7.6-1.1-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M109,138.9c-1.7,5.2-3.6,10.4-5,15.7-.4,1.5-.1,3-.7,4.6-.5,1.4-1.5,2.7-2.3,3.9-1.6,2.2-3.1,5.1-1.9,7.6.8,1.6,2.5,2.5,4.2,2.8,1.7.3,3.5,0,5.2,0,9.6-1,19.3-.5,28.9,0,1-7.1,1.8-14.1,2.4-21.2.5-6.1,1.4-12.8-.6-18.6-2.3-6.6-8-10.7-15.2-10-4.5.4-8.7,2.9-11.3,6.7-1.8,2.6-2.7,5.7-3.7,8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M218.6,212.8c-.6-1-1.3-2-2-3-3.4-4.4-8.4-8.2-12.9-11.4-5.9-4.2-11.8-8.3-17.5-12.6-5-3.8-10.3-8.5-16.2-10.9-3.3-1.3-7.3-3.6-10.9-2.2-3.3,1.2-6.2,4.1-7.7,7.3-1.6,3.3-2.1,7-2.1,10.6,0,2.8.4,5.6,1.8,8.1,2,3.4,5.6,5.4,9.2,7.1,4.5,2.1,8.9,4.4,13.5,6.5,5.8,2.5,11.2,5.9,16.2,9.9,3.4,2.8,6.8,6,11,7.1,3.5.9,6.8-.3,9.3-2.7,2.3-2.2,4.9-2.2,7.5-4.2.7-.6,1.4-1.2,1.8-2,.5-1,.5-2.2.3-3.3-.2-1.4-.8-2.8-1.5-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M53.7,505.2c1.8.5,3.6,1,5.4,1,4.2,0,8.5.1,12.7,0,2.4,0,2.4-.6,3.3-2.8.9-1.9,1.7-3.8,2.6-5.7,3.4-7.8,6.7-15.6,9.5-23.7,1.1-3.3,2.1-7.1.3-10.1-1.1-1.8-3.1-2.9-5.1-3.8-6-2.6-12.7-3.7-19.2-3-2.9.3-6,1-8.1,3-1.7,1.7-2.5,4.1-3.3,6.4-2.6,8.6-4.7,17.4-6,26.3-.7,4.7-.9,10.2,4.6,11.4,1,.2,2.1.6,3.3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M163.6,244.7c1.1,6.3,2.2,12.6,3.3,18.8,0,.5.1,1-.2,1.3-.2.2-.5.2-.7.2-18.7,2.9-37.3,5.7-56,8.6-1.3.2-2.5.4-3.8,0-.3,0-.6-.2-.9-.4-.4-.4-.2-1.1-.1-1.6.9-4.9-3-9-3.8-13.7-.5-3.4.8-9.3,4.2-11.1,1.8-1,4.3-.8,6.3-.8,3.3,0,6.6,0,10-.2,6.6-.1,13.1-.3,19.7-.5,7.4-.2,14.8-.4,22.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M139.4,128.3c-.7,3-.3,6.6-.2,8.9.2,4.3.9,10.2-1.4,13.9-2.3,3.6-5.2,6.8-8.6,9.4-2.6,2-3.7,4.3-5.3,7-.8,1.4-2,2.6-.9,4.2.6.9,1.6,1.4,2.7,1.8,2.4.8,4.9,1.1,7.4,1.2,5.4.2,10.8,0,16.2-.3.8,0,1.6,0,2.3-.5,1.1-.6,1.6-1.9,2-3.1.6-2.2.8-4.5.6-6.8-.2-2.3-.9-4.5-1-6.8-.1-2.6.5-5.3.6-7.9.1-3.7-.7-7.3-1.6-10.8-.7-3.1-1.5-6.1-2.2-9.2-.8-3.2-3.6-7.9-7.6-5.4-1.5.9-2.4,2.6-2.8,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M69.1,348.1c-5,12.9-8.5,26.3-10.5,39.9-1.8,12.2-2.3,24.7-5,36.7-4.3,19.3-14.2,37.1-17,56.7,16.9,5.7,37.9,6.2,55.6,6.8,1.7,0,9.2-34.7,9.8-37.3,4.1-14.9,8.2-29.8,12.3-44.7,4.6-16.6,9.1-33.2,12.4-50.2,1.5-7.9,2.2-15.6,5.1-23.1,2.9-7.4,6-14.8,7.8-22.6,2.1-9.2,2.4-18.7,1.7-28.1-.3-4.1-.4-8.6-1.1-12.6-.6-3.4-2.3-6.5-2.7-10-.6-4.6-2.8-9-7-10.9-4.1-1.9-11-1.8-12.3-6.1.8,2.8-8.7,9.8-10.4,11.5-15.2,15.6-15.7,35-21.8,54.8-3.3,10.6-8.8,20.4-13.3,30.5-1.3,2.9-2.5,5.8-3.6,8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M136.3,370.8c.2,2.2.4,4.5.5,6.7,1,17.9,1.2,35.9.7,53.8-.2,8.5-.6,17.1-2.3,25.5-2.3,9.3-1.5,18.6-2.2,27.9,15.9,1.5,32,1.3,48,1.1,1.6,0,4.1,0,5.1-1.3.7-.9.9-2.1,1.1-3.2.6-3.2,1.2-6.4,1.8-9.6.3-1.7.6-3.3.6-5,0-12,2.8-23.2,2.2-35.4-.9-16.7-1.8-33.4-2.7-50.1-1.8-33.4-4.1-66.8-9.5-99.8-1.7-10.2-6.4-18.3-11.4-27.3-2.7-4.9-4.3-7.4-9.5-9.6-3.1-1.3-8.3-4-11.7-2.5-4.6,2-7.7,6.4-9.3,11.1-1.3,3.9-5.2,6.6-6.1,10.6-.8,3.3.7,8.6.7,12.1,0,11.6-1.3,23.3-1.9,34.8-.4,7.1-1.6,15-.6,22.1,1.8,13,4.9,25.3,6.3,38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M160.1,173.3c-1-1.4-3.5-.9-5-1.1-2.5-.4-5-1.1-7.5-2-.9-.4-1.9-.8-2.4-1.6-.4-.6-.5-1.4-.6-2.2-.2-2-.4-4-.7-6-.3-2.5.1-3.5,2-5.1,2.5-2.2,3.1-5.8,3.2-9.1.2-5.2-.2-10.4-1.3-15.5-.3-1.5-.7-3-1.6-4.3-2.2-3.1-6.5-4-10-2.9-7.1,2.1-15.4,7.8-16.1,15.8-.3,3.7.6,7.4,1.3,11.1.9,4.6,1.5,9.4.4,13.9-1.1,4.6-4.2,8.9-8.7,10.2-1.4.4-2.9.5-4.1,1.3-1.8,1.1-1.3,2.2-.8,3.6.6,1.8.9,3.7,1.4,5.6,0,.2.1.4.2.6,0,0,0,.1,0,.2.8,2.4,2.2,4.6,4.3,6.2,4.3,3.9,10.7,6,16.6,5.6.2,0,.5,0,.7,0,0,0,.2,0,.3,0,11.5.2,23.4-5.9,26.7-17.6,0,0,0,0,0,0,1.1-2.4,2.6-5,1.6-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M157.2,172.8c-2.3,2.9-.7,8.3-3.5,11.2-2.4,2.6-7.1,8-21,7-9.1-.6-17.9-11.5-21.1-16-2.3.5-6.2,2-6.9,2.3-1,1.8.3,21.9-.5,31.1-1.1,13.1.1,25.6-1.1,39.4l60.8,1c0-5.4.5-10.9.8-16.3.4-6.2,0-12.1,1.6-18,2.5.8,5,1.2,7.6,1.4,3.1-8.5,7.1-16.6,11.2-24.6.7-1.3,2.8-3.9,2.6-5.4-.2-1.8-2.7-2.9-4.1-3.8-3.8-2.6-7.7-5.2-11.6-7.6-3.5-2.1-10.4-5.6-14.2-2.5-.2.2-.5.4-.7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M61.4,497.3c-1.4,0-16.7-1.2-16.6-1.3-.5,2.4-1,4.8-1.5,7.3,0,.4-.2.9-.4,1.2-.3.5-.9.8-1.5,1-9,3.9-19.4,4-28.1,8.5-.6.3-1.2.6-1.6,1.1-.8,1-.7,2.5,0,3.6.9,1.6,2.1,2.6,3.5,3.2h34.2c3.1-.6,5.9-1.9,8.7-4.6.3-.3.6-.6,1-.5.4,0,.6.5.8.9.5,1.3,1,2.6,1.4,4,3.1.2,6.2.4,9.3.5,2.6-5.2,5-10.7,6.3-16.4.6-2.8,1.2-5.6,1.8-8.5-5.7-.4-11.6.2-17.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M115.6,261.2c-.3.7-3.5,4.4-4.2,4.5-6.7,1.3-5.3.3-6,.3-11.7-9.8-24.6-39.9-27-53.4-.9-5.2.4-10.6,1.5-15.7.5-2.3,4.2-9.9,10-14,3.1-2.2,8.4-4.3,15.8-5.4,1.3,2,1.9,4.9,3.1,8,1.7,4.4,3.4,8.9,3.6,13.7.2,2.9-.2,5.9-1.7,8.4-.7,1.1-2.4,2.2-2.8,3.3-.7,1.7.4,3.7,1.2,5.5,4.3,9.7,7,20.1,8,30.6.4,4.8.2,9.6-1.5,14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.9,245.6c-3.5,5.6-2.8,12.8,1.8,17.5,1.7,1.7,3.5,3.1,5.7,4,.6.2,1.2.5,1.9.4.8,0,1.5-.4,2.2-.8,10.3-6.2,18.3-15.8,24-26.5,5.7-10.6,10.3-24,14.4-34.7.1-.3-8.4-7.7-10-8,0,0-6.1,7.5-9.2,11-9.3,10.4-22,22.3-30.7,36.7,0,.1-.1.2-.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M195.6,216.1c-1,.9-1.8,1.9-2.7,3-6.8,8.9-16.1,16.1-24.2,23.7-.3.3-.6.6-.8,1-1,2.7,3.2,12.6,6.8,11.8,9.2-2.2,18.1-8.2,25.8-13.5,4.7-3.2,9.5-6.5,13.4-10.7,3.5-3.7,7.3-9.8,6.2-15.1-1.5-7.5-11-8.3-16.8-5.6-2.9,1.3-5.5,3.1-7.8,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M147.8,181c-3.2,3-5.6,7-4.6,11.5.5,2.2,3.9,1.6,3.4-.5-.7-3.3,1-6.1,3.4-8.3,1.6-1.5-.6-4.2-2.2-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150,157h34.9c.5,0,1,.4,1,1v49.5c0,1-.8,1.8-1.8,1.8h-34.1c-1,0-1.8-.8-1.8-1.8v-48.7c0-1,.8-1.8,1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M161.6,180c-5.2,1.1-9.8,2.5-14.4,6.2-2.9,2.3-.1,4.4,1.8,3.1,4.2-2.8,8.7-4.7,13.6-5.8,2.3-.5,1.3-4-1-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M165.3,183.5c-5.9,1.5-11.4,4.1-16.9,6.7-2.1,1-.3,4.1,1.8,3.1,5.2-2.5,10.4-4.9,16-6.3,2.2-.6,1.3-4-1-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M165.1,188.5c-1.1-.3-2.3.2-3.3.5-1.3.4-2.7.9-4,1.4-2.5,1-5,2.3-7.3,3.7-2,1.2-.2,4.3,1.8,3.1,1.9-1.2,4-2.3,6.1-3.2,1-.4,2.1-.8,3.1-1.2.5-.2,1-.3,1.5-.5.1,0,1.1-.2,1.2-.4.6.1,1.2,0,1.6-.5,0,0,0,0,0,0,.9-1,.6-2.7-.8-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M162.7,193.5c-3.9,1.2-7.2,2.9-10.7,5-2,1.2-.2,4.3,1.8,3.1,3.2-2,6.3-3.6,9.9-4.7,2.2-.7,1.3-4.2-1-3.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M155.4,198.3c.3.4.4,1.1.3,1.7,0,.7-.5,1.4-.9,2-1.7,2.3-3.7,4.6-6.4,5.6-2.4.8-5.3.3-7.3-1.2-2-1.6-3.4-1.6-3.2-4.2,0-1.1,1.3-4.2,1.7-5.3,1-2.6,4.8-9.9,8.1-10.5,2.5-.5,4.1,7.4,7.6,12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M169,161.8c0,.9-.7,1.5-1.5,1.5s-1.5-.7-1.5-1.5.7-1.5,1.5-1.5,1.5.7,1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M78.2,220.4c5.3-1,10.7-1.2,16.1-1.9,6.7-.9,13.3-2,20.1-2.7,0,0,.1,0,.2-.1.4-.5.5-1.1.6-1.7,1.7-12.5-1.3-25.6-3-38,0-.4-.1-.8-.4-1-.3-.2-.7-.2-1.1-.1-6.7,1.1-13.7,2.3-19.4,6.1-.6.4-1.1.8-1.6,1.2-3.3,3.1-6.1,6.6-7.8,10-4.7,8.9-4.5,18.6-3.8,28.4,0,0,.1,0,.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M124.8,158.9c.5-2.2,1-4.4,1.6-6.6.8-2.9,1.7-5.7,3.1-8.3,1.2-2.4,2-4.7,3.2-7.1,1.2-2.7,4.2-4.6,7-4.9,1.9-.2,3.9,0,5.8-.4,2.8-.5,5.5-2.3,6.5-5,.9-2.7-.5-6.2-3.3-6.9-2.3-.6-4.2.7-6.3.9-2.3.2-3-.4-5.1-.8-4.5-.8-8.4.3-12.6,2.2-2.8,1.2-5.5,2.5-8.3,3.7-1.9.8-3.8,1.7-5.2,3.2-3.5,3.5-3.3,9.3-5.6,13.8-2,3.7-5.7,6.4-7.1,10.4-.6,1.7-.7,3.6-1.2,5.3-.8,2.7-2.5,5.2-2.7,8-.4,4.7,6.2,7.2,10,7.9,2.3.4,4.6.6,7,.7,2.8,0,6.7,0,8.7-2.1.8-.8,1.2-1.9,1.6-3,1.3-3.6,2.1-7.2,3-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128.9,149c-1.7.6-3.6.3-5.2-.6-.7-.4-1.3-1-1.7-1.8-.5-1-.5-2.1-.2-3.1.8-2.5,3.6-4.2,6.2-3.7,2,.4,2.5,1.5,3.2,3.4.7,1.9-1.3,4.1-2.4,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M143.3,248.6c.6,6.6.7,13.3.2,20-.2,2.8-.5,5.7-1.6,8.3-1.2,2.6-3.3,4.9-6.1,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M170.6,242.5c-1.4.5-2.7.8-4.1,1.1-1.2.2-2.4.4-3.7.7-1.4.2-3.6.5-4.4,1.7-1,1.3-.5,3.6-.3,5.1.4,2.3.9,4.7,2.3,6.7,1.9,2.9,4.6,3.6,7.6,2.1,4-1.9,8-3.8,11.5-6.5,3.2-2.4,6.5-5.3,7.1-9.2.3-2.1-.5-4.6-2.5-5.4-1.4-.6-3-.1-4.4.3-3.1.9-6.1,2.3-9.1,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M166.9,256.7c-4.6,1.9-9.4,2.9-14.3,3.1-.3,0-.6-.1-.9,0-.2,0-.5.1-.7.2-1.9.5-1.5,3.5.5,3.5,5.7,0,11.2-1.1,16.4-3.3,2.1-.9,1.2-4.3-.9-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M164,248.3c-5.9,1.3-11.8,2.2-17.8,2.9-2.2.3-2.3,3.8,0,3.5,6.3-.7,12.6-1.7,18.8-3,2.2-.5,1.3-3.9-.9-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M161.4,253.5c-4.5,1.1-9,1.7-13.7,1.8-2.3,0-2.3,3.6,0,3.5,4.9,0,9.8-.7,14.6-1.9,2.2-.5,1.3-3.9-.9-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M163.2,244.4l-16.8,2.3c-2.2.3-1.3,3.7.9,3.4l16.8-2.3c2.2-.3,1.3-3.7-.9-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M130.2,339.7c3.8-10.1,7.8-22.1,10.8-32.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M84.7,367.4c3.9,1.8,8.1,2.8,12.4,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M160.8,373.1c3.5.6,7.3.1,10.5-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M125,142.1c1.1-.4,2.3,0,3.1.8.7.8.9,2.2.4,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M109.3,215.9c.6,0,1.2-.1,1.8-.2-2.4-7.2-3.2-14.8-2.5-22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M148.5,154.7c-3.6,2.2-8.1,2.8-12.2,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M148.1,181.4c-3,2.2-5,5.6-5.4,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M154.4,202.1c-1.2,2.5-3.3,4.6-5.9,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M319,450.6h0c.9,1.9.3,4.1-1.3,4.8l-47.5,22.4c-1.6.8-3.6-.2-4.5-2.1h0c-.9-1.9-.3-4.1,1.3-4.8l47.5-22.4c1.6-.8,3.6.2,4.5,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M348,448.8c-1.4,12-12.2,20.5-24.2,19.1-12-1.4-20.5-12.2-19.1-24.2,1.4-12,12.2-20.5,24.2-19.1,12,1.4,20.5,12.2,19.1,24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M343.9,448.3c-1.1,9.7-9.9,16.6-19.6,15.5-9.7-1.1-16.6-9.9-15.5-19.6,1.1-9.7,9.9-16.6,19.6-15.5,9.7,1.1,16.6,9.9,15.5,19.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M312.7,447.6c1.5,7.1,8.4,12.2,15.6,11.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 267.3,
    y: 327.7,
    width: 160,
    height: 83.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "274 364 320.6 343.9 341.5 368.5 428.5 329.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "412 326.8 432.9 326.2 424.7 342.3 412 326.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 277.4,
    y: 367.8,
    width: 8.9,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 293.8,
    y: 359,
    width: 9,
    height: 47.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 310.2,
    y: 353,
    width: 8.7,
    height: 53.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 326.6,
    y: 363.3,
    width: 8,
    height: 43.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 343,
    y: 372.2,
    width: 9.2,
    height: 34.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 359.4,
    y: 367.8,
    width: 8.9,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 375.8,
    y: 357.4,
    width: 8.8,
    height: 49.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 392.3,
    y: 350.6,
    width: 8.3,
    height: 56.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 408.7,
    y: 343.9,
    width: 8.8,
    height: 63
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M402.1,411.5c9.7.2,12.4.2,21.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M285.8,411.5c37.4.2,46.8.2,84,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 178.4,
    y: 37.9,
    width: 163.2,
    height: 80.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 199.5,
    y1: 55.9,
    x2: 331.8,
    y2: 55.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 199.5,
    y1: 74,
    x2: 331.8,
    y2: 74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 199.5,
    y1: 92.2,
    x2: 331.8,
    y2: 92.2
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 211.8,
    y: 62.9,
    width: 163.2,
    height: 80.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 232.9,
    y1: 81,
    x2: 365.2,
    y2: 81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 232.9,
    y1: 99.1,
    x2: 365.2,
    y2: 99.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 232.9,
    y1: 117.2,
    x2: 365.2,
    y2: 117.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M329.3,142.5c10.3,0,21.1,0,31.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.9,142.5c33.7,0,66,0,99.8,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 211.1,
    y1: 69.2,
    x2: 211.1,
    y2: 131.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 382.7,
    y: 143.2,
    width: 163.2,
    height: 81.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 539.7,
    y: 167.1,
    width: 24.5,
    height: 75.6,
    transform: "translate(105.9 589.2) rotate(-61.1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "494.9 173.4 512.9 197.4 524.8 175.9 494.9 173.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "494.9 173.4 512.9 197.4 524.8 175.9 494.9 173.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "503.4 184.8 509 174.6 494.9 173.4 503.4 184.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 583.3,
    y1: 226.3,
    x2: 516.5,
    y2: 189.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 586.8,
    y1: 220,
    x2: 520,
    y2: 183.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.8,
    y: 155.7,
    width: 26.5,
    height: 26.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 441.5,
    y: 155.7,
    width: 26.5,
    height: 26.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.8,
    y: 186.3,
    width: 26.5,
    height: 26.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 441.5,
    y: 186.3,
    width: 26.5,
    height: 26.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "394.2 162.4 408.1 176.3 427.6 152.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "394.2 193.1 408.1 207 427.6 183.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "445.7 162.4 459.6 176.3 479.1 152.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "445.7 193.1 459.6 207 479.1 183.3"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "556.4 194.5 591 212.5 579.2 233.9 534.1 208.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M495.7,224.3h21.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M396.5,224.3c29.1.2,60.1.2,89.8,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 340.3,
    y: 233.1,
    width: 163.2,
    height: 83.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 384.1,
    cy: 278.4,
    r: 26.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M384.1,278.4l-1.1-36.1c.4,0,.7,0,1.1,0,19.8,0,36.1,16.3,36.1,36.1h-36.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M384.1,278.4l-19.1,24.9c-.4-.3-.8-.6-1.2-.9-7-5.9-11.1-14.6-11.2-23.8l31.4-.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M490.5,280.5c-2.7,14.1-16.4,23.5-30.6,20.8-14.1-2.7-23.5-16.4-20.8-30.6,2.7-14.1,16.4-23.5,30.6-20.8s23.5,16.4,20.8,30.6ZM450.8,272.9c-1.5,7.7,3.6,15.2,11.3,16.7,7.7,1.5,15.2-3.6,16.7-11.3s-3.6-15.2-11.3-16.7c-7.7-1.5-15.2,3.6-16.7,11.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "428.9 268.4 465.1 275.9 444.9 244.4 428.9 268.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "438.3 252.6 467.9 274.7 464.5 240.4 438.3 252.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "463.3 241.4 464.7 275.8 492.8 253.8 463.3 241.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.5 307.4 465.6 276 447.5 303.4 477.5 307.4"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M388.6,304.7c-4.9.9-9.9.4-14.5-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M409.1,287.5c-2.7,7.1-8.4,12.8-15.4,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M456,278.6c.8,3,3.1,5.3,6.1,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M463.5,266.1c-3.9.6-6.7,3.5-7.6,7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M468.6,284.3c6.1-2.8,7.6-11.4,2.5-15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M354,313.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M465.4,316.6h27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M356.3,316.6c5.9.1,2.3.2,8.2.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M270.6,171.9l-6.5,8.5c-.4.7-.6,1.4-.6,2.3v43.7c0,2.5,2,4.5,4.6,4.5l42.1-.2c.6,0,2.8.1,3.9-.9,1.5-1.5,5.4-4.7,7.1-6.1.4-.4.5-1,0-1.4l-50.5-50.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.1,170.1h47c1.8,0,3.3,1.5,3.3,3.3v47.3c0,1.8-1.5,3.3-3.3,3.3h-47c-1.8,0-3.3-1.5-3.3-3.3v-47.3c0-1.8,1.5-3.3,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.4,219.6c0,2.4-2,4.4-4.4,4.4h-10.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 323.4,
    y1: 184.8,
    x2: 323.4,
    y2: 206.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.8,186.2v-11.6c0-2.4,2-4.4,4.4-4.4h44.7c2.4,0,4.4,2,4.4,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M291.3,224.1h-17.1c-2.4,0-4.4-2-4.4-4.4v-16.8"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "311.9 192.4 297.2 178.3 281.2 192.4 288.9 192.4 288.9 215.3 304.2 215.3 304.2 192.4 311.9 192.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M448.9,457.7c-.2-12.4-10.8-22.3-23.4-21.4-10.6.7-19.3,9.3-20.2,19.9-.6,7.6,2.7,14.5,8.1,18.8,3.3,2.7,5.6,6.4,6.1,10.6l1.4,11.7,13.6-.2,1-11.8c.4-4.2,2.5-8,5.7-10.8,4.8-4.1,7.8-10.2,7.7-16.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M431.4,489.3c.9-4.9,1.8-9.8,2.7-14.7.6-3.5,1.3-6.9,1.9-10.4.5-2.7,2.9-7.6-1.5-8.4-1.6-.3-3.4,1-3.3,2.7,0,.4.2.7.4,1,.7.7,2.2.2,2.4-.8.2-1-.5-2-1.4-2.5-1.8-.8-4.2.5-4.4,2.5,0,.2,0,.4,0,.5.3.4.9.1,1.1-.2.5-.8,0-1.9-.8-2.4-.8-.4-1.9-.3-2.8,0-1.3.5-2.6,1.8-2.1,3.1,0,.3.3.5.5.6.2,0,.3,0,.5,0,2.5-1.1-.9-4.9-3.3-3.7-1.4.7-2.2,2.4-2.3,4,0,1.6.4,3.2.8,4.7,2.1,7.5,3.4,15.2,3.8,23,0,1,0,1-.4,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M393.7,452.4c3.9.5,2.7.4,6.7.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 399.5,
    y1: 436.2,
    x2: 404.7,
    y2: 440.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M420.6,425.7c.3,1.7.7,4.5,1,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M434.9,425c-.5,3.7-.8,6.2-1,7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M455.5,439.8c-3.4,2.4-3.1,2.2-6.6,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M454.1,454.8c4.1.3,3.1.2,7.2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M438.9,444c4.1,3,6.6,8,6.3,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M444.4,464.4c-.7,2.5-2.1,4.7-4,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M419.5,488.3h15.9v12.2c0,.9-.8,1.7-1.7,1.7h-12.5c-.9,0-1.7-.8-1.7-1.7v-12.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M504.9,379.6c-.2,0-.4,0-.6,0-2.9-.2-5.1-2.7-4.8-5.6.2-2.9,2.8-5,5.7-4.8.2,0,.4,0,.6,0-.2-2-.5-4-1.1-6-.2,0-.3.2-.5.3-2.6,1.3-5.8.2-7-2.4-1.2-2.6-.1-5.7,2.5-7,.2,0,.4-.1.5-.2-1.2-1.7-2.5-3.2-4-4.6,0,.2-.2.3-.3.5-1.7,2.4-5,3-7.4,1.4-2.4-1.6-3-4.9-1.3-7.3.1-.2.3-.3.4-.5-1.9-.9-3.8-1.6-5.8-2,0,.2,0,.4,0,.6-.2,2.9-2.8,5-5.7,4.8-2.9-.2-5.1-2.7-4.8-5.6,0-.2,0-.4.1-.7-2.1.2-4.1.5-6.2,1.1.1.2.2.4.3.6,1.2,2.6.1,5.7-2.5,7-2.6,1.3-5.8.2-7-2.4-.1-.2-.2-.5-.3-.7-1.8,1.2-3.4,2.6-4.8,4,.2.1.4.2.7.4,2.4,1.6,3,4.9,1.3,7.3-1.7,2.4-5,3-7.4,1.4-.2-.2-.4-.3-.6-.5-.9,1.9-1.7,3.9-2.2,5.9.3,0,.5,0,.8,0,2.9.2,5.1,2.7,4.8,5.6-.2,2.9-2.8,5-5.7,4.8-.3,0-.6,0-.9-.1.2,2.1.5,4.2,1.1,6.2.2-.2.5-.3.7-.4,2.6-1.3,5.8-.2,7,2.4,1.2,2.6.1,5.7-2.5,7-.3.1-.5.2-.8.3,1.2,1.8,2.6,3.4,4.1,4.8.1-.2.2-.5.4-.7,1.7-2.4,5-3,7.4-1.4,2.4,1.6,3,4.9,1.3,7.3-.2.2-.4.4-.5.6,1.9.9,3.9,1.6,6,2.1,0-.3,0-.5,0-.8.2-2.9,2.8-5,5.7-4.8,2.9.2,5.1,2.7,4.8,5.6,0,.3,0,.5-.1.8,2.1-.2,4.2-.6,6.2-1.2-.1-.2-.3-.4-.4-.6-1.2-2.6-.1-5.7,2.5-7,2.6-1.3,5.8-.2,7,2.4.1.2.2.4.2.6,1.7-1.2,3.3-2.6,4.8-4-.2,0-.4-.2-.6-.3-2.4-1.6-3-4.9-1.3-7.3,1.7-2.4,5-3,7.4-1.4.2.1.3.3.5.4.9-1.9,1.6-3.8,2.1-5.8ZM476.9,386.7c-8.1,1.8-16.1-3.3-17.9-11.3-1.7-8,3.5-16,11.7-17.8,8.1-1.8,16.1,3.3,17.9,11.4,1.7,8-3.5,16-11.7,17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M551.9,369.4c-.9-1.4-2-2.6-3.2-3.7,0,.1-.1.3-.2.4-1.3,1.9-4,2.4-5.9,1.1-1.9-1.3-2.4-3.9-1.1-5.8,0-.1.2-.2.3-.4-1.5-.7-3.1-1.2-4.7-1.6,0,.2,0,.3,0,.5-.2,2.3-2.2,4-4.6,3.9-2.3-.2-4.1-2.2-3.9-4.5,0-.2,0-.4,0-.5-1.7.1-3.3.4-4.9.9,0,.1.2.3.3.4,1,2.1,0,4.6-2,5.6-2.1,1-4.6.1-5.6-1.9,0-.2-.1-.4-.2-.6-1.4,1-2.7,2.1-3.9,3.2.2,0,.4.2.5.3,1.9,1.3,2.4,3.9,1.1,5.8-1.3,1.9-4,2.4-5.9,1.1-.2-.1-.3-.3-.5-.4-.7,1.5-1.3,3.1-1.7,4.7.2,0,.4,0,.6,0,2.3.2,4.1,2.2,3.9,4.5-.2,2.3-2.2,4-4.6,3.9-.2,0-.5,0-.7-.1.1,1.7.4,3.3.9,5,.2-.1.4-.2.6-.3,2.1-1,4.6-.1,5.6,1.9,1,2.1,0,4.6-2,5.6-.2.1-.4.2-.7.2,1,1.4,2.1,2.7,3.3,3.8,0-.2.2-.4.3-.6,1.3-1.9,4-2.4,5.9-1.1,1.9,1.3,2.4,3.9,1.1,5.8-.1.2-.3.4-.4.5,1.5.7,3.1,1.3,4.8,1.7,0-.2,0-.4,0-.6.2-2.3,2.2-4,4.6-3.9,2.3.2,4.1,2.2,3.9,4.5,0,.2,0,.4-.1.6,1.7-.2,3.3-.5,5-1-.1-.2-.2-.3-.3-.5-1-2.1,0-4.6,2-5.6,2.1-1,4.6-.1,5.6,1.9,0,.2.1.3.2.5,1.4-1,2.7-2.1,3.8-3.2-.2,0-.3-.1-.4-.2-1.9-1.3-2.4-3.9-1.1-5.8,1.3-1.9,4-2.4,5.9-1.1.1,0,.3.2.4.3.7-1.5,1.3-3.1,1.7-4.6-.2,0-.3,0-.5,0-2.3-.2-4.1-2.2-3.9-4.5.2-2.3,2.2-4,4.6-3.9.2,0,.3,0,.5,0-.1-1.6-.4-3.2-.9-4.8-.1,0-.2.2-.4.2-2.1,1-4.6.1-5.6-1.9-1-2.1,0-4.6,2-5.6.1,0,.3-.1.4-.2ZM544.5,377.4c3.6,7.5.3,16.5-7.3,20.1-7.6,3.6-16.7.5-20.3-7-3.6-7.5-.3-16.5,7.3-20.1,7.6-3.6,16.7-.5,20.3,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M546.8,376.2c4.2,8.8.4,19.3-8.5,23.6-8.9,4.2-19.5.6-23.8-8.2-4.2-8.8-.4-19.3,8.5-23.6,8.9-4.3,19.6-.6,23.8,8.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M511.3,521.7c15.1-.2,28.6-.2,43,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M284.7,521.6c71,0,142.3,0,213.7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M209.5,527.8c71,0,142.3,0,213.7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M19.6,521.7c84.8-.2,168.1-.2,252.9-.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M280.6,259.6c19,0,34.5,15.4,34.5,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M280.6,272.7c11.8,0,21.4,9.6,21.4,21.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M280.6,284.1c5.5,0,10,4.5,10,10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalAiBannerIllustrations);
export default __webpack_public_path__ + "static/media/physical-ai-banner-illustrations.7c53bdc62976e362c74a33c4ab0eaf73.svg";
export { ForwardRef as ReactComponent };